import image from '../../images/Stories (1).png';
import image2 from '../../images/Stories (2).png';
import image3 from '../../images/Stories (3).png';
import image4 from '../../images/Stories (4).png';
import image5 from '../../images/Stories (5).png';

const StoriesSection = () => {
  const stories = [
    {
      id: 1,
      type: 'large',
      badge: 'Climate Tech',
      title: 'Business Partnerships',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image2,
      readMoreText: 'Read Blog'
    },
    {
      id: 2,
      type: 'large',
      badge: 'Community Impact',
      title: 'Community Impact',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image3,
      readMoreText: 'Read Blog'
    },
    {
      id: 3,
      type: 'small',
      badge: 'Carbon Offset',
      title: 'Carbon Offset Projects',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image4,
      readMoreText: 'Read Blog'
    },
    {
      id: 4,
      type: 'small',
      badge: 'NGO Partnerships',
      title: 'NGO Collaborations',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image5,
      readMoreText: 'Read Blog'
    },
    {
      id: 5,
      type: 'small',
      badge: 'Social Impact',
      title: 'Bring Hope - Feed A Soul',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image,
      readMoreText: 'Read Blog'
    }
  ];

  const LargeCard = ({ data }) => (
    <div className="flex flex-col items-start pb-6 gap-6 w-full max-w-[588px] md:min-h-[520px] lg:min-h-[550px] mx-auto">
      {/* Image Container */}
      <div className="relative w-full h-[280px] md:h-[340px] lg:h-[361px] rounded-t-xl overflow-hidden">
        <img
          src={data.image}
          alt={data.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      {/* Content Container */}
      <div className="flex flex-col items-start gap-2 w-full px-4 md:px-0">
        {/* Meta Row */}
        <div className="flex flex-row items-center gap-2 h-[25px]">
          <div className="bg-[#004617] rounded px-1.5 py-0.5 h-[25px] flex items-center">
            <span className="text-white font-medium text-[13px] md:text-[13px] lg:text-[14px] leading-[21px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
              {data.badge}
            </span>
          </div>
          <div className="w-2.5 h-2.5 bg-[#D9D9D9] rounded-full"></div>
          <span className="text-[#898989] font-medium text-[13px] md:text-[13px] lg:text-[14px] leading-[17px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.date}
          </span>
        </div>

        {/* Title & Description */}
        <div className="flex flex-col items-start gap-2 w-full mt-2">
          <h3 className="text-[#141414] font-bold text-[20px] md:text-[22px] lg:text-[24px] leading-[27px] md:leading-[28px] lg:leading-[29px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.title}
          </h3>
          <p className="text-[#3B3B3B] font-normal text-[14px] md:text-[15px] lg:text-[16px] leading-[20px] md:leading-[21px] lg:leading-[22px] w-full">
            {data.description}
          </p>
        </div>

        {/* Read More Link */}
        <div className="flex flex-row items-center gap-1 mt-3 cursor-pointer group transition-all duration-150 hover:opacity-80">
          <span className="text-[#0D924F] font-medium text-[14px] md:text-[15px] lg:text-[16px] leading-[19px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.readMoreText}
          </span>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6H15M15 6L10 1M15 6L10 11" stroke="#0D924F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  );

  const SmallCard = ({ data }) => (
    <div className="flex flex-col items-start gap-6 w-full max-w-[384px] md:min-h-[470px] lg:min-h-[489px] mx-auto">
      {/* Image Container */}
      <div className="relative w-full h-[240px] md:h-[280px] lg:h-[302px] rounded-t-xl overflow-hidden">
        <img
          src={data.image}
          alt={data.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      {/* Content Container */}
      <div className="flex flex-col items-start gap-2 w-full px-4 md:px-0">
        {/* Meta Row */}
        <div className="flex flex-row items-center gap-2 h-[25px]">
          <div className="bg-[#004617] rounded px-1.5 py-0.5 h-[25px] flex items-center">
            <span className="text-white font-medium text-[13px] md:text-[13px] lg:text-[14px] leading-[21px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
              {data.badge}
            </span>
          </div>
          <div className="w-2.5 h-2.5 bg-[#D9D9D9] rounded-full"></div>
          <span className="text-[#898989] font-medium text-[13px] md:text-[13px] lg:text-[14px] leading-[17px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.date}
          </span>
        </div>

        {/* Title & Description */}
        <div className="flex flex-col items-start gap-2 w-full mt-2">
          <h3 className="text-[#141414] font-bold text-[20px] md:text-[22px] lg:text-[24px] leading-[27px] md:leading-[28px] lg:leading-[29px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.title}
          </h3>
          <p className="text-[#3B3B3B] font-normal text-[14px] md:text-[15px] lg:text-[16px] leading-[20px] md:leading-[21px] lg:leading-[22px] w-full line-clamp-3">
            {data.description}
          </p>
        </div>

        {/* Read More Link */}
        <div className="flex flex-row items-center gap-1 mt-3 cursor-pointer group transition-all duration-150 hover:opacity-80">
          <span className="text-[#0D924F] font-medium text-[14px] md:text-[15px] lg:text-[16px] leading-[19px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.readMoreText}
          </span>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6H15M15 6L10 1M15 6L10 11" stroke="#0D924F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col items-start gap-4 w-full mb-10 md:mb-16 lg:mb-20 max-w-[1400px] mx-auto lg:mx-0 px-4 md:px-6 lg:px-8 xl:px-16 lg:ml-64 mt-10 md:mt-16 lg:mt-20">
      {/* Section Title */}
      <h2 className="text-[#0D924F] font-bold text-[28px] md:text-[32px] lg:text-4xl leading-[38px] md:leading-[40px] lg:leading-[43px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Stories
      </h2>

      {/* Two rows: 2 large cards, then 3 small cards */}
      <div className="flex flex-col gap-6 w-full">
        {/* Row 1 — 2 large cards */}
        <div className="flex flex-col md:flex-row items-stretch gap-6 w-full">
          <div className="w-full md:flex-1 md:min-w-0">
            <LargeCard data={stories[0]} />
          </div>
          <div className="w-full md:flex-1 md:min-w-0">
            <LargeCard data={stories[1]} />
          </div>
        </div>

        {/* Row 2 — 3 small cards */}
        <div className="flex flex-col md:flex-row  gap-6 w-full">
          <div className="w-full md:flex-1 md:min-w-0">
            <SmallCard data={stories[2]} />
          </div>
          <div className="w-full md:flex-1 md:min-w-0">
            <SmallCard data={stories[3]} />
          </div>
          <div className="w-full md:flex-1 md:min-w-0">
            <SmallCard data={stories[4]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoriesSection;